var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */
import { Translate } from "../../I18N";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { wrapDispatch } from "../../Multireducer";

import { Icon } from "../../UI";
import { NeedAuthorization } from "../../Auth";
import { SortDropdown } from "./SortDropdown";
import LibraryModeToggleButtons from "./LibraryModeToggleButtons";
import {
zoomIn as zoomInAction,
zoomOut as zoomOutAction } from "../actions/libraryActions";

import { showFilters as showFiltersAction } from "../../Entities/actions/uiActions";


import { HiddenColumnsDropdown } from "./HiddenColumnsDropdown";











const mapStateToProps = (state) => ({
  filtersPanel: state.library.ui.get('filtersPanel'),
  search: state.library.search,
  selectedDocuments: state.library.ui.get('selectedDocuments'),
  multipleSelected: state.library.ui.get('selectedDocuments').size > 1,
  rowListZoomLevel: state.library.ui.get('zoomLevel')
});

const mapDispatchToProps = (dispatch) =>
bindActionCreators(
{ zoomIn: zoomInAction, zoomOut: zoomOutAction, showFilters: showFiltersAction },
wrapDispatch(dispatch, 'library'));


const connector = connect(mapStateToProps, mapDispatchToProps);



const FiltersButton = ({
  tableViewMode,
  showFilters



}) => /*#__PURE__*/
_jsx("div", { className: `toggle-button ${!tableViewMode ? 'only-mobile' : 'unpinned'}` }, void 0, /*#__PURE__*/
_jsx("button", { type: "button", className: "btn btn-default", onClick: showFilters }, void 0, /*#__PURE__*/
_jsx(Icon, { icon: "funnel-filter" }), /*#__PURE__*/
_jsx("span", { className: "filters-label" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Show filters")), /*#__PURE__*/

_jsx("span", { className: "tab-link-tooltip" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Show filters"))));





const LibraryHeaderComponent = ({
  filters,
  selectAllDocuments,
  counter,
  SearchBar,
  searchCentered,
  zoomIn,
  zoomOut,
  tableViewMode,
  scrollCount = 0,
  showFilters
}) => {
  const [toolbarVisible, setToolbarVisible] = useState(false);
  const toggleToolbarVisible = () => {
    setToolbarVisible(!toolbarVisible);
  };

  useEffect(() => {
    if (toolbarVisible && scrollCount > 0) {
      setToolbarVisible(false);
    }
  }, [scrollCount]);

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("div", { className: `library-header ${!toolbarVisible ? 'closed' : ''}` }, void 0, /*#__PURE__*/
    _jsx("div", { className: "library-toolbar" }, void 0,
    SearchBar !== undefined && /*#__PURE__*/
    _jsx("div", { className: `search-list ${searchCentered ? 'centered' : ''}` }, void 0, /*#__PURE__*/
    _jsx(SearchBar, {})), /*#__PURE__*/


    _jsx("div", { className: "header-bottom" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sort-by" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "documents-counter-sort" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "sorted by")), /*#__PURE__*/

    _jsx(SortDropdown, { selectedTemplates: filters.get('documentTypes') }), /*#__PURE__*/
    _jsx(NeedAuthorization, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "select-all-documents" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "btn btn-default btn-xs",
      onClick: selectAllDocuments }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Select all"))))), /*#__PURE__*/




    _jsx(LibraryModeToggleButtons, {
      zoomIn: zoomIn,
      zoomOut: zoomOut,
      tableViewMode: tableViewMode,
      zoomLevel: 0,
      searchUrl: "",
      showGeolocation: false }), /*#__PURE__*/

    _jsx("div", { className: "documents-counter" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "documents-counter-label" }, void 0, counter)),

    tableViewMode && /*#__PURE__*/_jsx(HiddenColumnsDropdown, {}), /*#__PURE__*/
    _jsx(FiltersButton, { tableViewMode: tableViewMode, showFilters: showFilters }))), /*#__PURE__*/


    _jsx("div", { className: "close-toolbar-button" }, void 0, /*#__PURE__*/
    _jsx("button", { type: "button", className: "toggle-toolbar-button", onClick: toggleToolbarVisible }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Hide toolbar")))), /*#__PURE__*/




    _jsx("div", { className: `open-toolbar-button ${toolbarVisible ? 'closed' : ''}` }, void 0, /*#__PURE__*/
    _jsx("button", { type: "button", className: "toggle-toolbar-button", onClick: toggleToolbarVisible }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Show toolbar")))));




};

const container = connector(LibraryHeaderComponent);

export { container as LibraryHeader };